import React, { useState } from "react";
import USQSFormGroup from "./USQSFormGroup";
import useUSQS from "../../hooks/useUSQS";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import "./QSUSA.css";
import { ignoreEnter, addEdits, handleProductSelect, handleInputSelect } from "./utils/inputhandlers";
import SearchField from "../SearchField/SearchField";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import useLoadUSpositions from "./hooks/useLoadUSpositions";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { decimToPercent } from "./utils/transformators";

const QSUSAGeneral = ({
  clearfield,
  setClearfield,
  navpostoedit,
  setNavpostoedit,
  showUSposList,
  setShowUSposList,
  setReloadPoslistdata,
  reloadPoslistdata,
}) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  // Load Contexts
  const { USQS, setUSQS, setUSQSData, qstoedit, setPpaymenttermUSQS, setPpaymenttermDataUSQS, whdata, setWhdata } =
    useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, undoListUSQS, inputRefsUSQS, setEditingFieldUSQS } = useUSQSUndo();
  // States
  // Hooks
  const usposlist = useLoadUSpositions("loadactiveuspositions", reloadPoslistdata);
  // Functions

  // navigate to positionsUSA and send navpostoedit to load it
  const handleNavToUSPos = () => {
    navigate("/positions/usa", { state: { positiontoedit: navpostoedit } });
  };

  // load Position into QS
  const loadPositionToQS = async (item) => {
    // console.log(item);
    setNavpostoedit(item.USposID);
    const currency = ["materialcost"];
    const dates = ["shipfrom", "shipuntil"];
    const quantities = ["materialcost"];
    const addedvals = ["WGP", "product", "supplier", "bagSize", "bagMarkType"];
    const addeddata = ["WGP", "productID", "supplierID", "bagSizeID", "bagMarkTypeID"];
    const keepvals = [...currency, ...dates, ...addedvals];
    const keepdata = [...dates, ...quantities, ...addeddata];
    try {
      const response = await axiosPrivate.post("/api/qs/loadPosToQS", {
        WGP: item.WGP,
      });
      const addvals = Object.fromEntries(
        Object.entries(response.data[0])
          .filter(([key]) => keepvals.includes(key))
          .map(([key, value]) => {
            if (currency.includes(key)) {
              return [key, `$${parseFloat(value).toFixed(2)}`];
            } else if (dates.includes(key)) {
              return [key, moment(value).format("YYYY-MM-DD")];
            } else if (quantities.includes(key)) {
              return [key, Number(value)];
            } else {
              return [key, value];
            }
          })
      );
      const adddata = Object.fromEntries(
        Object.entries(response.data[0])
          .filter(([key]) => keepdata.includes(key))
          .map(([key, value]) => {
            if (dates.includes(key)) {
              return [key, moment(value).format("YYYY-MM-DD")];
            } else if (quantities.includes(key)) {
              return [key, Number(value)];
            } else {
              return [key, value];
            }
          })
      );
      setClearfield(!clearfield);
      setUSQS((prev) => ({ ...prev, ...addvals }));
      setUSQSData((prev) => ({ ...prev, ...adddata }));
      // console.log(addvals, adddata);
      USQSEdits.current.push(
        {
          editID: editIDUSQS,
          name: "WGP",
          value: addvals.WGP,
          num: adddata.WGP,
          figuretype: "integer",
        },
        {
          editID: editIDUSQS,
          nameID: "productID",
          valueID: adddata.productID,
          name: "product",
          value: addvals.product,
        },
        {
          editID: editIDUSQS,
          nameID: "supplierID",
          valueID: adddata.supplierID,
          name: "supplier",
          value: addvals.supplier,
        },
        {
          editID: editIDUSQS,
          nameID: "bagSizeID",
          valueID: adddata.bagSizeID,
          name: "bagSize",
          value: addvals.bagSize,
        },
        {
          editID: editIDUSQS,
          nameID: "bagMarkTypeID",
          valueID: adddata.bagMarkTypeID,
          name: "bagMarkType",
          value: addvals.bagMarkType,
        },
        {
          editID: editIDUSQS,
          name: "shipfrom",
          value: addvals.shipfrom,
          num: adddata.shipfrom,
          figuretype: "text",
        },
        {
          editID: editIDUSQS,
          name: "shipuntil",
          value: addvals.shipuntil,
          num: adddata.shipuntil,
          figuretype: "text",
        },
        {
          editID: editIDUSQS,
          name: "materialcost",
          value: addvals.materialcost,
          num: adddata.materialcost,
          figuretype: "currency",
        },
        {
          editID: editIDUSQS,
          num: item.USposID,
          figuretype: "posloadedtoqs",
        }
      );
    } catch (err) {
      console.error(err);
    }
    try {
      const response1 = await axiosPrivate.post("/api/qs/loadPosPaytermsToQS", {
        positionID: item.USposID,
      });
      let ppterm = response1.data.map(({ portion, payType, termdays }) => ({
        portion: decimToPercent(portion),
        payType,
        termdays,
      }));
      let pptermdata = response1.data.map(({ portion, payTypeID, termdays }) => ({
        portion,
        payTypeID,
        termdays,
      }));
      setPpaymenttermUSQS(ppterm);
      setPpaymenttermDataUSQS(pptermdata);
      USQSEdits.current.push({
        editID: editIDUSQS,
        data: pptermdata,
        vals: ppterm,
        figuretype: "ptermsfrompos",
      });
    } catch (err) {
      console.error(err);
    }
    try {
      const response2 = await axiosPrivate.post("/api/qs/loadWHtoQS", {
        positionID: item.USposID,
      });
      setWhdata(response2.data[0]);
      setUSQS((prev) => ({ ...prev, ["whexit"]: moment().format("YYYY-MM-DD") }));
      setUSQSData((prev) => ({ ...prev, ["whexit"]: moment().format("YYYY-MM-DD") }));
    } catch (err) {
      console.error(err);
    }
    setEditIDUSQS((prev) => prev + 1);
    setShowUSposList(false);
  };

  return (
    <>
      {/* <div className='addQSUSA-1'> */}
      <USQSFormGroup readOnly={true} labelname={"QSID"} inputname={"USQSID"} />
      <USQSFormGroup readOnly={true} type={"date"} labelname={"QS Date"} inputname={"QSDate"} />
      <fieldset style={{ overflow: "visible" }}>
        <legend>Quote From:</legend>
        <div className='purchasefrom form-group'>
          <label>
            <input
              name='qstype'
              type='radio'
              checked={USQS && USQS.qstype === 1 ? true : false}
              onClick={(e) => {
                setUSQS((prev) => ({ ...prev, ["qstype"]: 1 }));
                setUSQSData((prev) => ({ ...prev, ["qstype"]: 1 }));
                USQSEdits.current.push({
                  editID: editIDUSQS,
                  name: e.target.name,
                  value: 1,
                  num: 1,
                  figuretype: "radio",
                });
                setEditIDUSQS((prev) => prev + 1);
                setEditingFieldUSQS(false);
                undoListUSQS.current = [];
              }}
              value={USQS.qstype}
              required
            />
            Back-to-back
          </label>
        </div>
        <div
          className='purchasefrom form-group'
          style={{ display: "flex", flexDirection: "row", position: "relative", overflow: "visible" }}
        >
          <label>
            <input
              name='qstype'
              type='radio'
              checked={USQS && USQS.qstype === 2 ? true : false}
              onClick={(e) => {
                setUSQS((prev) => ({ ...prev, ["qstype"]: 2, ["pincoterm"]: "EXW" }));
                setUSQSData((prev) => ({ ...prev, ["qstype"]: 2, ["pincotermID"]: 1 }));
                USQSEdits.current.push(
                  {
                    editID: editIDUSQS,
                    name: e.target.name,
                    value: 2,
                    num: 2,
                    figuretype: "radio",
                  },
                  {
                    editID: editIDUSQS,
                    nameID: "pincotermID",
                    name: "pincoterm",
                    value: "EXW",
                    valueID: 1,
                  }
                );
                setEditIDUSQS((prev) => prev + 1);
                setEditingFieldUSQS(false);
                undoListUSQS.current = [];
              }}
              value={USQS.qstype}
              required
            />
            US Position
          </label>
          <div style={{ position: "relative", overflow: "visible" }}>
            {USQS.qstype === 2 && (
              <button type='button' onClick={() => setShowUSposList(true)}>
                Select Position
              </button>
            )}

            {showUSposList && (
              <ListWithFilters
                data={usposlist}
                columns={["USposID", "WGP", "product", "supplier", "quantity", "sold", "inventory"]}
                mainclass='USQS-lwf-pos'
                rowID='WGP'
                onRowClick={loadPositionToQS}
                placeHolders={true}
                placeHolderList={["USposID", "WGP", "Product", "Supplier", "Quantity", "Sold", "Inventory"]}
                size={["S", "S", "M", "M", "S", "S", "S"]}
                setReloadlistdata={setReloadPoslistdata}
              />
            )}
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Identifiers:</legend>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <USQSFormGroup
            readOnly={USQS.qstype === 2}
            labelname={"WGP"}
            inputname={"WGP"}
            inputtype={"integer"}
            cplaceholder={"WGP..."}
            required={false}
          />
          {USQS.qstype === 2 && USQS.WGP && (
            <button type='button' onClick={() => handleNavToUSPos()} style={{ margin: 0, height: "25px" }}>
              Go
            </button>
          )}
        </div>
        <USQSFormGroup
          labelname={"WGSUS"}
          inputname={"WGS"}
          inputtype={"integer"}
          cplaceholder={"WGSUS..."}
          required={false}
        />
      </fieldset>
      <fieldset>
        <legend>General:</legend>
        <div className='form-group'>
          <label>Product:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/qs/getprodsupplier'
            value={USQS?.product || ""}
            valueName='product'
            secondaryValueName='supplier'
            valueID='productID'
            style={{ width: "90%" }}
            customplaceholder='Select Product'
            onItemSelect={(item) => {
              handleProductSelect(
                item,
                setUSQS,
                setUSQSData,
                USQSEdits,
                addEdits,
                editIDUSQS,
                setEditIDUSQS,
                undoListUSQS
              );
            }}
            clearfield={clearfield}
          />
        </div>
        <div className='form-group'>
          <label>Supplier:</label>
          <input
            readOnly
            placeholder='Supplier...'
            onKeyDown={ignoreEnter}
            name={"supplierID"}
            value={USQS?.supplier || ""}
          />
        </div>
        <div className='form-group'>
          <label>Customer:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/qs/getcustomers'
            value={USQS?.customer || ""}
            valueName='customer'
            valueID='customerID'
            style={{ width: "90%" }}
            customplaceholder='Select Customer'
            onItemSelect={(item) => {
              handleInputSelect(
                item,
                USQSEdits,
                editIDUSQS,
                setEditIDUSQS,
                setUSQS,
                setUSQSData,
                addEdits,
                undoListUSQS,
                "customer",
                "customer"
              );
            }}
            clearfield={clearfield}
          />
        </div>
      </fieldset>
    </>
    //  </div>
  );
};

export default QSUSAGeneral;
